import React from "react";
import Chart from "react-apexcharts";

function TotalNetoPorQuincenaChart() {
  const data = {
    series: [
      {
        name: "Total Neto",
        // Aquí van los valores en "miles"; por ejemplo: 401 mil = 401
        data: [
          401, 608, 439, 436, 621, 455, 464, 1201, 413,
          883, 884, 606, 908, 478, 702, 550, 514, 796,
          1174, 467, 493, 1373, 3699
        ],
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 400,
      },
      title: {
        text: "Total Neto por Quincena (Incluye pagos adicionales)",
        align: "left",
      },
      xaxis: {
        // Etiquetas del eje X
        categories: [
          "Q202401", "Q202402", "Q202403", "Q202404", "Q202405", 
          "Q202406", "Q202407", "Q202408", "Q202409", "Q202410", 
          "Q202411", "Q202412", "Q202413", "Q202414", "Q202415", 
          "Q202416", "Q202417", "Q202418", "Q202419", "Q202420",
          "Q202421", "Q202422", "Q202423", "Q202424"
        ],
        title: {
          text: "QNA OK",
        },
        labels: {
          // Opcional: si deseas mostrar "mil." en cada etiqueta del eje X
          // En este caso, cada “categoría” no es un número, por lo que no formateamos
        },
      },
      yaxis: {
        title: {
          text: "Suma de Total Neto",
        },
        labels: {
          // Agrega " mil." al final de la etiqueta en el eje Y
          formatter: (val) => val + " mil.",
        },
      },
      plotOptions: {
        bar: {
          columnWidth: "70%",
          distributed: false, // 'false' si no quieres distintos colores por barra
          dataLabels: {
            position: "top", // Posiciona las etiquetas en la parte superior de cada barra
          },
        },
        
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => `${val} mil.`,
        offsetY: -30, // Desplaza las etiquetas 15px hacia abajo desde el "top" de la barra
        style: {
          colors: ["#313131"], // Cambia el color del texto a #313131
          fontSize: "14px",   // Ajusta el tamaño si es necesario
          fontWeight: "bold", // Opcional, para hacerlo más legible
        },
        
      },
      colors: ["#8B572A"], // Color café aproximado
      grid: {
        borderColor: "#e7e7e7",
        row: {
          colors: ["#f3f3f3", "transparent"], // Alternar color de filas
          opacity: 0.5,
        },
      },
      tooltip: {
        y: {
          formatter: (val) => val + " mil.",
        },
      },
      legend: {
        show: false,
      },
    },
  };

  return (
    <div style={{ width: "100%", margin: "0 auto" }}>
      <Chart
        options={data.options}
        series={data.series}
        type="bar"
        height={400}
      />
    </div>
  );
}

export default TotalNetoPorQuincenaChart;
